import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import {
  createAndSendExternalInvitation,
  CreateAndSendExternalInvitationParams,
} from './create-and-send-external-invitation.action';

type Params = {
  projectId: number;
  limitDate: string;
  eventPosition: PositionGeocode | undefined;
};

export const createExternalInvitationPublic = createAppAsyncThunk(
  'externalInvitation/createExternalInvitationPublic',
  async (params: Params, { dispatch }): Promise<void> => {
    const arg: CreateAndSendExternalInvitationParams = {
      projectId: params.projectId,
      name: '',
      email: '',
      limitDate: params.limitDate,
      eventPosition: params.eventPosition,
      title: '',
      sector: 'PUBLIC',
      scope: 'PUBLIC',
    };
    dispatch(createAndSendExternalInvitation(arg));
  },
);
